export const WebhooksConfigurationLocation = {
	MODAL: 'MODAL',
	SECTION: 'SECTION',
} as const;
export type WebhooksConfigurationLocation =
	(typeof WebhooksConfigurationLocation)[keyof typeof WebhooksConfigurationLocation];
